import { render, staticRenderFns } from "./PatientTrends.vue?vue&type=template&id=392be6f1&"
import script from "./PatientTrends.vue?vue&type=script&lang=js&"
export * from "./PatientTrends.vue?vue&type=script&lang=js&"
import style0 from "./PatientTrends.vue?vue&type=style&index=0&id=392be6f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports